import { AxiosResponse } from 'axios';

import { productCatalogueHttp } from '@gn-audio/jss-core';

import { ProductIncludeType } from 'common/types/productTypes';

import { SearchItem, SearchParameters, SearchResults } from './productCatalogueApiTypes';

export const fetchProductCatalogSearchResults = async (
  searchSuffix: string,
  parameters: SearchParameters,
  includeType: string = ProductIncludeType.Available
): Promise<SearchResults<SearchItem> | null> => {
  const url = `/search/${searchSuffix}?include=${includeType}`;

  try {
    const { data } = await productCatalogueHttp.post<
      SearchParameters,
      AxiosResponse<SearchResults<SearchItem>>
    >(url, parameters);
    return data;
  } catch (error) {
    console.error(`fetchProductCatalogSearchResults request for ${searchSuffix} failed:`, error);
    return null;
  }
};
